import styled from 'styled-components'
import { device } from '../../utils/mixins'

const Container = styled.div`
  display: flex;
  flex-direction: ${props => props.direction || 'column'};
  flex-wrap: ${props => props.wrap || 'initial'};
  padding: 0 20px;
  max-width: 1092px;
  margin: 0 auto;
  width: 100%;

  @media ${device.tablet} {
    padding: 0 30px;
  }

  @media ${device.tabletLand} {
    padding: 0 50px;
  }
`
export default Container
